import WaveSurfer from 'wavesurfer.js';

const initAudio = ( selector ) => {

    if ( !selector ) return;
    
    const parent = $(selector).closest( '[data-audio-block]' );

    let wavesurfer = {};
    wavesurfer = WaveSurfer.create({
        container: '#' + $(selector).attr('id'),
        waveColor: '#DEDEDE',
        progressColor: '#999999',
        cursorColor: '#4353FF',
        barWidth: 2,
        barRadius: 2,
        cursorWidth: 0,
        height: 40,
        barGap: 5,
    });

    $(selector).data('wavesurfer', wavesurfer);

    wavesurfer.on('error', function(e) {
        console.warn(e);
    });

    wavesurfer.on('pause', function () {
        parent.removeClass('play').addClass('pause');
    });

    wavesurfer.on('ready', function () {
        parent.addClass('stop');
    });

    wavesurfer.on('play', function () {
        parent.addClass('play').removeClass('stop pause');
    });

    wavesurfer.load(selector.data('audio-track'));
}

export const initAudioTracks = () => {
    $('[data-audio-track]').each( function() {
        initAudio($(this));
    });

    $(document).on( 'click', '[data-audio-btn]', function() {
        const parent = $(this).closest( '[data-audio-block]' );
        const track = parent.find( '[data-audio-track]' );

        $( '[data-audio-track]' ).not( track ).each( function() {
            $(this).data('wavesurfer').pause();
        });

        track.data('wavesurfer').playPause();
    } )
}